import { computed, inject, Injectable, signal } from "@angular/core"
import { LoadingAbstraction } from "@common/ports/abstractions";
import { PortfolioAbstraction } from "../../../portfolio/ports/abstraction";
import { lastValueFrom } from "rxjs";
import { PortfolioInterface } from "../../../portfolio/ports/interfaces";

@Injectable({
    providedIn: 'root'
})
export class PortfolioListClientService {
    private loadingAbstraction = inject(LoadingAbstraction);
    private portfolioAbstraction = inject(PortfolioAbstraction);

    private listPortfolioTemp = signal<PortfolioInterface[]>([]);

    public listPortfolio = computed(() => this.listPortfolioTemp());

    async getListPortfolio(): Promise<void> {
        this.loadingAbstraction.show();

        const resp = await lastValueFrom(this.portfolioAbstraction.listPortfolioClient())
        this.listPortfolioTemp.update(value => value = (resp && resp.data.length > 0) ? resp.data[0].data : []);
    }
}